import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-overlay-loader',
    templateUrl: './overlay-loader.component.html',
    standalone: true,
    imports: [MatProgressSpinnerModule]
})
export class OverlayLoaderComponent {

    constructor() { }

}
